import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { useResizeModal } from '../../Modal'
import { BuildingForm } from '../BuildingForm'

import { QA_NAME_BUILDING_CREATION_MODAL } from './BuildingFormModal.constants'

function BuildingFormModal({
  title = 'Modal.NewBuildingTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  return (
    <BuildingForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_BUILDING_CREATION_MODAL,
        setCloseConfirm,
        title: t(title),
        onClose,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      contentComponentProps={{ isFullScreen: isMobileScreenSize || fullScreen }}
      setModal={setModal}
      onCancel={handleClose}
    />
  )
}

export default BuildingFormModal
